import { Component, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Hub } from 'aws-amplify/utils';
import { CognitoService } from '../../services/cognito.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './app-toolbar.component.html',
    styleUrls: ['./app-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButtonModule]
})
export class AppToolbarComponent implements OnInit {
  private cognitoService = inject(CognitoService);

  public version: string = "1.0"
  isAuthenticated = signal(false);

  ngOnInit(): void {
    this.version = this.cognitoService.version;
    this.checkAuth();
    Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn') this.isAuthenticated.set(true);
      if (payload.event === 'signedOut') this.isAuthenticated.set(false);
    });
  }

  private async checkAuth() {
    try {
      await this.cognitoService.currentAuthenticatedUser();
      this.isAuthenticated.set(true);
    } catch {
      this.isAuthenticated.set(false);
    }
  }

  async signOut() {
    await this.cognitoService.signOut();
  }
}
